<template>
  <div class="factory">
    <Head></Head>
    <Pc
      v-if="!isPhone"
      v-show="tab === 'store'"
      ref="factoryPc"
      @changeTab="changeTab"
    ></Pc>
    <Pc2
      v-if="!isPhone"
      v-show="tab === 'storep'"
      ref="factoryPc2"
      @changeTab="changeTab"
    ></Pc2>
    <Mobile
      v-show="tab === 'store'"
      ref="factoryMobile"
      @changeTab="changeTabMobile"
      v-if="isPhone"
    ></Mobile>
    <Mobile2
      v-show="tab === 'storep'"
      ref="factoryMobile"
      @changeTab="changeTabMobile"
      v-if="isPhone"
    ></Mobile2>
    <Foot></Foot>
  </div>
</template>

<script>
import Head from "@/components/header-index.vue";
import Foot from "@/components/footer-index.vue";
import Pc from "./idPc.vue";
import Mobile from "./idMobile.vue";
import Pc2 from "../id-storep/idPc.vue";
import Mobile2 from "../id-storep/idMobile.vue";
export default {
  name: "factory",
  components: {
    Head,
    Foot,
    Pc,
    Mobile,
    Pc2,
    Mobile2,
  },
  data() {
    return {
      isPhone: false,
      tab: "store",
    };
  },
  created() {
    // 判断是否手机
    this.getIsPhone();
    // 设置标题
    this.setTitle();
  },
  methods: {
    changeTab(val) {
      console.log(val);
      this.tab = val;
    },
    changeTabMobile(val) {
      console.log(val);
      this.tab = val;
    },
    getIsPhone() {
      var userAgentInfo = navigator.userAgent;
      var Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod",
      ];
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          this.isPhone = true;
        }
      }
    },
    setTitle() {
      document.title = "揭秘ID.家族潮趣触点";
    },
  },
};
</script>
